module.exports = __webpack_public_path__ + "img/redjik_logo.9b09edc5.png";